import React from "react";
import ExperienceCard from "../cards/ExperienceCard";

// Style \\
import "../../assets/styles/sections/experience.scss";

import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Experience = () => {
  return (
    <section className="experience">
      <div className="container">
        <div className="experience_items">
          <div className="title">
            <h3>You can see</h3>
            <p>My Experience</p>
          </div>

          <div className="experience_cardBox">
            <Swiper
              className="swipperHead"
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={105}
              slidesPerView={3}
              pagination={{ clickable: true }}
              onSlideChange={() => console.log("slide change")}
            >
              <SwiperSlide>
                <ExperienceCard />
              </SwiperSlide>
              <SwiperSlide>
                <ExperienceCard />
              </SwiperSlide>
              <SwiperSlide>
                <ExperienceCard />
              </SwiperSlide>

              <SwiperSlide>
                <ExperienceCard />
              </SwiperSlide>
              <SwiperSlide>
                <ExperienceCard />
              </SwiperSlide>

              <div className="dot">...</div>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
